import { DocumentDesign } from "../api/types";
import { CanvasPaperConfig } from "../designer/PageDesigner/PageDesigner";
import { PaperOrientation } from "../designer/paper.constants";

const isPaperOrientation = (value?: string): value is PaperOrientation =>
  Object.values<string>(PaperOrientation).includes(value ?? "");

/**
 * The stored orientation is a free-form string, so it is narrowed on the way in
 * rather than asserted: designs saved before the field existed have none, and
 * anything the app cannot lay out is treated as the default, portrait.
 */
function toPaperOrientation(orientation?: string): PaperOrientation {
  return isPaperOrientation(orientation)
    ? orientation
    : PaperOrientation.Portrait;
}

export function getDocumentDesignPaperConfig(
  design: DocumentDesign,
): CanvasPaperConfig {
  const paperSize = JSON.parse(design.paper_config.paper_size);

  return {
    height: paperSize.height,
    width: paperSize.width,
    paddingDirections: JSON.parse(design.paper_config.padding_directions),
    orientation: toPaperOrientation(design.paper_config.orientation),
    pageBreakMargin: design.paper_config.page_break_margin ?? 0,
  };
}
